import axios from 'axios';
import { filter,findIndex } from 'lodash';
import { action,makeAutoObservable, runInAction } from 'mobx';

import type { IMedia } from '../../components/MediaUploader/store';

export interface IEquipment {
  uuid: string;
  title: string;
  image: IMedia | null;
}

export interface IEquipmentStore {
  equipment: IEquipment[];
  isLoading: boolean;

  postEquipment(data: IEquipment): Promise<void>;

  editEquipment(data: IEquipment): Promise<void>;

  deleteEquipment(uuid: string): Promise<void>;
}

export default class EquipmentStore implements IEquipmentStore {
  equipment: IEquipment[] = [];
  isLoading = false;

  constructor() {
    makeAutoObservable(this);
  }

  @action
  async postEquipment(data: IEquipment) {
    const result = await axios.post('/api/equipment', data);
    runInAction(() => {
      this.equipment.push(result?.data);
    });
  }

  @action
  async editEquipment(data: IEquipment) {
    const result = await axios.put(`/api/equipment/${data.uuid}`, data);
    const index = findIndex(this.equipment, ['uuid', data.uuid]);
    runInAction(() => {
      if (index !== -1) {
        this.equipment[index] = result?.data;
      }
    });
  }

  @action
  async deleteEquipment(uuid: string) {
    await axios.delete(`/api/equipment/${uuid}`);

    runInAction(() => {
      this.equipment = filter(this.equipment, (x) => x.uuid !== uuid);
    });
  }
}
